import * as tslib_1 from "tslib";
export function canShowTooltip(_a) {
    var hasNotification = _a.hasNotification, isMobile = _a.isMobile, allowMobile = _a.allowMobile, hasChildren = _a.hasChildren, hasPopover = _a.hasPopover, hasTooltip = _a.hasTooltip;
    // if no children, nothing to show
    if (!hasChildren) {
        return false;
    }
    // if we have a notification, always show it
    if (hasNotification) {
        return true;
    }
    // mobile is explicitly opt-in
    // and we only care for the popover
    if (isMobile) {
        return allowMobile && hasPopover;
    }
    // need at least something to render
    return hasTooltip || hasPopover;
}
export function getPopperProps(notification, showTooltip, popoverProps, tooltipOffset, onClose) {
    if (notification) {
        return tslib_1.__assign({}, popoverProps, { isOpen: true, showArrow: true, positionOnly: false, placement: 'top-start', modifiers: {
                offset: {
                    offset: tooltipOffset || '0, 8',
                },
            } });
    }
    if (showTooltip === 'tooltip') {
        return {
            isOpen: true,
            modifiers: {
                offset: {
                    offset: tooltipOffset || '0, 8',
                },
            },
        };
    }
    return tslib_1.__assign({}, popoverProps, { isOpen: showTooltip === 'popover', onClickOutside: onClose, disablePlacementModifier: true, modifiers: {
            offset: {
                offset: tooltipOffset || '0, 8',
            },
        } });
}
//# sourceMappingURL=helpers.js.map